import styled from "styled-components";
import {
	TABLET_M_BP,
	DESKTOP_L_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import { isBusinessVerticalB2U } from "@website-builder/utilities/utils/helpers.js";
const isB2U = isBusinessVerticalB2U();

export const HypeCardWrapper = styled.div`
	padding: 80px 0;
	.card-container .bottom-container {
		margin: 0;
		& ul {
			margin-bottom: 16px;
		}
	}
	.card-header {
		margin-bottom: 32px;
	}
	.salary-heading {
		color: ${({ salaryHeadingColor }) =>
			isB2U && salaryHeadingColor
				? salaryHeadingColor
				: "var(--secondary-blue-300)"};
		${isB2U
			? `
        font-size: 2.75rem;
        font-weight: 600;
        `
			: ""}
		margin-bottom: 0.5rem;
	}
	.salary-title {
		margin-bottom: 0.5rem;
	}
	.salary-description {
		font-size: 0.75rem;
		color: var(--secondary-gray-dark);
	}
	.middle-section {
		display: flex;
		& .content-section {
			padding: 0 48px;
			width: 100%;
		}
	}
	.right-section {
		padding-left: 24px;
	}
	.left-section {
		padding-right: 24px;
	}
	.card-container {
		padding: 40px 48px;
	}
	.card-container .hype-card-logo {
		max-height: 30px;
	}
	.list-header,
	.icon-header,
	.cta-description {
		margin-bottom: 1rem;
	}
	.logo-list > div {
		align-items: center;
	}
	.cta-description p {
		margin-bottom: 1rem;
		font-family: inherit;
		color: inherit;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 40px 0;
		.card-container {
			padding: 40px 24px;
		}
		.card-header {
			margin-bottom: 16px;
		}
		.middle-section {
			display: block;
			& .content-section {
				padding: 0;
			}
		}
		.right-section {
			padding-left: 0px;
		}
		.left-section {
			padding-right: 0px;
		}
		.bottom-container {
			grid-template-columns: repeat(6, minmax(0, 1fr));
			margin: 0;
			& > div {
				padding-bottom: 16px;
				&:not(:last-child) {
					border-bottom: 1px solid rgba(5, 8, 43, 0.3);
				}
			}
		}
	}
	@media only screen and (min-width: ${TABLET_M_BP}px) and (max-width: ${DESKTOP_L_BP}px) {
		.bottom-container {
			margin: 0;
			grid-template-columns: repeat(3, 50px) repeat(9, minmax(0, 1fr));
			& ul {
				margin-bottom: 16px;
			}
		}
	}
`;

export const ListItemWrapper = styled.div`
	text-align: start;
	.item-description {
		margin: 0;
	}
`;
